import { OAuthRedirect } from './OAuthRedirect';

export const SalesforceOAuthRedirect = () => {
  return <OAuthRedirect provider="Salesforce" apiEndpoint="sfAgent" authCodePath="authCode" />;
};
